import React, { useEffect, useRef, useState } from 'react'
import { Download } from 'lucide-react'

export default function RestoredCustomerEvidence({ token }) {
  const [files, setFiles] = useState([])
  const [error, setError] = useState('')
  const [busy, setBusy] = useState('')
  const active = useRef(null)
  const inFlight = useRef(false)
  useEffect(() => {
    const controller = new AbortController()
    active.current = controller
    setFiles([])
    setError('')
    setBusy('')
    inFlight.current = false
    fetch('/.netlify/functions/customer-portal-data?restoredEvidence=true', { headers: { Authorization: `Bearer ${token}` }, signal: controller.signal })
      .then(async response => { const data = await response.json(); if (!response.ok) throw new Error(data.error || 'Could not load restored files.'); return data })
      .then(data => { if (!controller.signal.aborted) setFiles(data.files || []) })
      .catch(err => { if (!controller.signal.aborted) setError(err.message) })
    return () => { controller.abort(); active.current = null }
  }, [token])
  async function open(file) {
    if (inFlight.current) return
    const controller = active.current
    if (!controller || controller.signal.aborted) return
    inFlight.current = true
    setBusy(file.id)
    setError('')
    // Reserve the tab synchronously; a delayed fetch cannot bypass popup protection.
    const tab = window.open('about:blank', '_blank')
    if (tab) tab.opener = null
    try {
      const response = await fetch(`/.netlify/functions/customer-portal-data?evidenceId=${encodeURIComponent(file.id)}`, { headers: { Authorization: `Bearer ${token}` }, signal: controller.signal })
      const payload = await response.json()
      if (controller.signal.aborted) { tab?.close(); return }
      if (!response.ok) throw new Error(payload.error || 'Could not open this file.')
      const url = new URL(payload.signed_url)
      if (!['https:', 'http:'].includes(url.protocol)) throw new Error('Invalid file link.')
      if (tab) tab.location.href = url.href
      else throw new Error('Your browser blocked the file window. Please allow it and retry.')
    } catch (err) { tab?.close(); if (!controller.signal.aborted) setError(err.message) }
    finally { if (!controller.signal.aborted) { inFlight.current = false; setBusy('') } }
  }
  return <section style={{ marginTop: 20 }}>
    {error && <div className="alert alert-error" role="alert">{error}</div>}
    {!!files.length && <><h2 style={{ fontSize: 18 }}>Restored evidence</h2>{files.map(file => <div key={file.id} style={{ padding: '12px 0', display: 'flex', gap: 12, alignItems: 'center', borderBottom: '1px solid var(--border)' }}>
      <span style={{ flex: 1, minWidth: 0, overflowWrap: 'anywhere' }}>{file.job_number}: {file.file_name}</span>
      <button className="btn btn-ghost btn-sm" disabled={!!busy} title={`Open ${file.file_name}`} onClick={() => open(file)}><Download size={16} /> Open</button>
    </div>)}</>}
  </section>
}
